module.exports = __webpack_public_path__ + "img/supplier-en.9d7ad236.png";